<template>
	<div class="c-person-selector layout layout--flush pt--">
		<div
			class="c-person-selector__person layout__item u-4/24"
			:class="{active: p.count <= selectedPersonCount, hover: p.hover}"
			v-for="p in persons"
			@click="selectPersonCount(p)"
			@mouseenter="setHoverState(p)"
			@mouseleave="resetHoverState()"
			:key="p.elec"
		>
			<svg width="13" height="20" viewBox="0 0 13 30" xmlns="http://www.w3.org/2000/svg">
				<path
					d="M12.513 16.105c.19.876-.314 1.592-1.123 1.592H9.926l-.134 1.625-.718 9.054C9.003 29.269 8.332 30 7.58 30H4.852c-.752 0-1.424-.731-1.495-1.624l-.718-9.054-.137-1.625H1.103c-.774 0-1.252-.716-1.061-1.592l1.45-6.683c.19-.876 1.079-1.592 1.975-1.592h5.621c.897 0 1.785.716 1.975 1.592l1.45 6.683L6.84 1.921m2.687 1.33a3.25 3.25 0 1 0-6.5-.001 3.25 3.25 0 0 0 6.5 0"
				/>
			</svg>
		</div>
	</div>
</template>

<script>
export default {
	props: {
		personCount: {
			type: Number,
			default: () => 3
		}
	},
	data() {
		return {
			selectedPersonCount: 3,
			persons: [
				{
					count: 1,
					title: 'Eenpersoonshuishouden',
					elec: 1800,
					gas: 1100,
					hover: false
				},
				{
					count: 2,
					title: 'Tweepersoonshuishouden',
					elec: 2700,
					gas: 1200,
					hover: false
				},
				{
					count: 3,
					title: 'Klein gezin',
					elec: 3500,
					gas: 1500,
					hover: false
				},
				{
					count: 4,
					elec: 4500,
					title: 'Gemiddeld gezin',
					gas: 1700,
					hover: false
				},
				{
					count: 5,
					elec: 5000,
					gas: 1900,
					title: 'Groot gezin',
					hover: false
				}
			]
		};
	},
	async mounted() {
		this.persons.forEach(p => {
			p.tooltip = `<h4>${p.title}</h4>
			Stroomverbruik: <b>${p.elec} kWh</b><br>
			Gasverbruik: <b>${p.gas} m<sup>3</sup>`;
		});
		this.selectPersonCount(this.persons[this.personCount - 1]);
	},
	methods: {
		setHoverState(person) {
			this.persons.forEach(p => {
				p.hover = p.count <= person.count;
			});
		},
		resetHoverState() {
			this.persons.forEach(p => (p.hover = false));
		},
		selectPersonCount(person) {
			this.selectedPersonCount = person.count;
			this.$emit('changeusage', {
				elec: person.elec,
				gas: person.gas,
				personCount: person.count
			});
		}
	}
};
</script>
